import { Suspense, type FC, lazy, type ComponentProps } from "react";
import { retryLazyLoad } from "@root/shared/utils/retryLazyLoad";
import { type Props } from "./type";
import type { Presentation as PresentationProps } from "./Presentation";

const Presentation = lazy(() =>
  retryLazyLoad<ComponentProps<typeof PresentationProps>>({
    fn: () => import("./Presentation").then((module) => ({ default: module.Presentation })),
  }),
);

export const MoreInterviewCassettesSlider: FC<Props> = ({ moreInterviewCassette }) => {
  return (
    <Suspense fallback={null}>
      <Presentation moreInterviewCassette={moreInterviewCassette} />
    </Suspense>
  );
};
